"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsAgentsAreaInsightsWrapper$ = exports.StatsAgentsAreaInsightsWrapper$outboundSchema = exports.StatsAgentsAreaInsightsWrapper$inboundSchema = void 0;
exports.statsAgentsAreaInsightsWrapperToJSON = statsAgentsAreaInsightsWrapperToJSON;
exports.statsAgentsAreaInsightsWrapperFromJSON = statsAgentsAreaInsightsWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const statsagentsareainsightsattribute_js_1 = require("./statsagentsareainsightsattribute.js");
/** @internal */
exports.StatsAgentsAreaInsightsWrapper$inboundSchema = z.object({
    attributes: statsagentsareainsightsattribute_js_1.StatsAgentsAreaInsightsAttribute$inboundSchema,
    id: z.string(),
    type: z.literal("agent_id").default("agent_id").optional(),
});
/** @internal */
exports.StatsAgentsAreaInsightsWrapper$outboundSchema = z.object({
    attributes: statsagentsareainsightsattribute_js_1.StatsAgentsAreaInsightsAttribute$outboundSchema,
    id: z.string(),
    type: z.literal("agent_id").default("agent_id"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StatsAgentsAreaInsightsWrapper$;
(function (StatsAgentsAreaInsightsWrapper$) {
    /** @deprecated use `StatsAgentsAreaInsightsWrapper$inboundSchema` instead. */
    StatsAgentsAreaInsightsWrapper$.inboundSchema = exports.StatsAgentsAreaInsightsWrapper$inboundSchema;
    /** @deprecated use `StatsAgentsAreaInsightsWrapper$outboundSchema` instead. */
    StatsAgentsAreaInsightsWrapper$.outboundSchema = exports.StatsAgentsAreaInsightsWrapper$outboundSchema;
})(StatsAgentsAreaInsightsWrapper$ || (exports.StatsAgentsAreaInsightsWrapper$ = StatsAgentsAreaInsightsWrapper$ = {}));
function statsAgentsAreaInsightsWrapperToJSON(statsAgentsAreaInsightsWrapper) {
    return JSON.stringify(exports.StatsAgentsAreaInsightsWrapper$outboundSchema.parse(statsAgentsAreaInsightsWrapper));
}
function statsAgentsAreaInsightsWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StatsAgentsAreaInsightsWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StatsAgentsAreaInsightsWrapper' from JSON`);
}
//# sourceMappingURL=statsagentsareainsightswrapper.js.map